{
  "name": "@uppy/unsplash",
  "description": "Import files from Unsplash, the free stock photography resource, into Uppy",
  "version": "6.0.0",
  "license": "MIT",
  "type": "module",
  "sideEffects": false,
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build"
  },
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin",
    "unsplash"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "preact": "^10.29.2"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "publishConfig": {
    "access": "public"
  },
  "devDependencies": {
    "@uppy-dev/tsconfig": "workspace:^",
    "@uppy/core": "workspace:^",
    "typescript": "^6.0.3"
  }
}
